<template>
    <BreadCrumb PageTitle="Modifier un montant" />
    <EditMontant />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditMontant from "../../components/Montant/EditMontant.vue";
  
    export default defineComponent({
      name: "EditMontantPage",
      components: {
        BreadCrumb,
        EditMontant,
      },
    });
  </script>